import React, { useState, useEffect } from "react";
import CertificateModal from "../Verify Certificate/VerifyCertificateModal";
import Instance from "../../AxiosConfig";

const VerifyCertificate = () => {
  const [showModal, setShowModal] = useState(false);
  const [certificateData, setCertificateData] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [certificateNumber, setCertificateNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const[clientName,setClientName]=useState("");

  const handleSearch = async () => {
    setLoading(true);

    try {
      const response = await Instance.get(
        `Certification/search?companyName=${clientName}&certificationNumber=${certificateNumber}`,
        
      );

      console.log("API Response:", response.data);

      if (response.status === 200 || response.status === 201) {
        const data = response.data.certification; 
        setCertificateData(data);
        setShowModal(true);
        console.log("Saved Certificate Data:", response.data.certification);

      }
    } catch (error) {
      console.error("Error fetching certificate:", error);
      setCertificateData(null);
      setShowModal(true);
    } finally {
      setLoading(false);
      setClientName("");
      setCertificateNumber("")
    }
  };

  // remove handleSearch from useEffect or add conditional
  useEffect(() => {
    if (clientName && certificateNumber) {
      handleSearch();
    }
  }, []); // runs only once

  const handleButtonClick = () => {
    if (!clientName || !certificateNumber) {
      alert("Please enter both Company Name and Certificate No");
      return;
    }
    handleSearch();
  };

  return (
    <div className="container verify-certificate">
      <form className="verify-certificate-form" onSubmit={(e) => e.preventDefault()}>
        <h5 className="verify-title">VERIFY CERTIFICATE</h5>

        {/* Certificate No */}
        <div className="d-flex align-items-center mt-4 verify-certificate-companyno">
          <label className="verify-label">Certificate No :</label>
          <input
            type="text"
            className="verify-form-input"
            value={certificateNumber}
            onChange={(e) => setCertificateNumber(e.target.value)}
          />
        </div>

        {/* Company Name */}
        <div className="d-flex align-items-center mt-4 verify-certificate-company-name">
          <label className="verify-label">Client Name :</label>
          <input
            type="text"
            className="verify-form-input"
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
          />
        </div>

        {/* Search Button */}
        <div className="d-flex justify-content-end mt-4">
          <button
            type="button"
            className="verify-btn"
            onClick={handleButtonClick}
            disabled={loading}
          >
            {loading ? "Searching..." : "Search"}
          </button>
        </div>
      </form>

      {/* Modal Component */}
      <CertificateModal
        show={showModal}
        onHide={() => setShowModal(false)}
        data={certificateData}
        loading={loading}
      />
    </div>
  );
};

export default VerifyCertificate;
